import { render, staticRenderFns } from "./modalTypeOfBill.vue?vue&type=template&id=36b45b10&"
import script from "./modalTypeOfBill.vue?vue&type=script&lang=js&"
export * from "./modalTypeOfBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports